export enum StatisticType {
  Sleep = "Hlídání spánku",
  Steps = "Kroky",
  Water = "Pitný režim",
  HeartRate = "Měření tepu",
  Pressure = "Měření tlaku",
}
